export default title => {
  let iframeTitle;
  try {
    iframeTitle = title ? decodeURIComponent(title) : null;
  } catch (e) {
    iframeTitle = title;
  }
  return iframeTitle;
};
